<template>
  <div>
    <div v-if="!slug">
      <section class="grid-flex wrap">
        <div class="item flex-1 box flex middle center-txt column">
          <div class="box-content">
            <div>
              <h2>RECEBA PARA DIVULGAR A ÚNICO TRACKER!</h2>
            </div>
            <div class="margin-top-m">
              <h3>Seja nosso AFILIADO na KIWIFY</h3>
            </div>
            <div class="margin-top-m ">
              <h3 class="destaque">GANHE 30% DE FORMA RECORRENTE!</h3>
            </div>
            <div class="margin-top-m">
              <h3>30 dias de Cookies!</h3>
              <small>(Não perde o lead, tem até 30 dias para comprar)</small>
            </div>
            <div class="margin-top-m">
              <h3>Aprovação Automática</h3>
              <small>(Divulgue seu link ainda hoje)</small>
            </div>

            <div class="button secondary margin-top-l">
              <a
                href="https://dashboard.kiwify.com.br/join/affiliate/diDmfyHy"
                target="_blank"
              >
                <div class="">
                  <img width="180" src="@/assets/img/inter/kiwify.png" />
                  <p>
                    <small
                      >Seja nosso afiliado e ganhe 30% de recorrência!!</small
                    >
                  </p>
                </div>
              </a>
            </div>

            <div class="margin-top-l">
              <p><b>Atenção:</b> O que é proibido fazer:</p>
              <ul class="margin-top-s" style="text-align: left">
                <li>
                  Criar páginas falsas com nome da ÚNICO TRACKER ou do seu fundador Renan.
                </li>
                <li>
                  Rodar campanhas com o nome "Único Tracker", "unicotracker.com.br" ou "Único Tracker.com".
                </li>
                <li>
                  Fazer falsas promessas, mentir sobre o sistema.
                </li>
                <li>
                  Prometer novas funcionalidades.
                </li>
                <li>
                  Se passar pela equipe ou fundadores da ÚNICO TRACKER.
                </li>
              </ul>
              <div class="margin-top-l">
                <p>Esses termos podem ser alterados a qualquer momento.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="flex center-txt margin-top-l">
        <p>
          Ficou com alguma dúvida? A gente responde:
          <a href="mailto:contato@unicotracker.com.br"
            >contato@unicotracker.com.br</a
          >
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "affiliate",
  components: {},
  props: ["slug"],
  data() {
    return {
      loading: false,
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  min-width: 300px;
  min-height: 130px;
  margin-top: 16px;
  margin-left: 0px !important;
  margin-right: 20px;

  a {
    width: 100%;
    height: 100%;

    &:hover {
      color:#fff;
    }
  }
}

.disabled-box {
  background: #e8e8e8;
  > a {
    cursor: none;
  }
}

.tag {
  background: var(--primary);
  color: #fff;
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 10px;
  font-weight: 600;
}

.destaque {
  color: var(--terciary) !important;
  font-size: 32px;
}
</style>
